export const buttonColorScheme = {
    errorButton: "danger",
    createButton: "info",
    infoButton: "primary",
    actionButton: "rose"
  }
